import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import SendIcon from "@mui/icons-material/Send";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { isDefinedString } from "et3-type-guards";
import i18n from "../../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import { khattabaConversationParsing } from "../../../../../../helpers/et3-conversation-parse";
import getCorePersonalStore from "../../../../../../stores/core/core-personal-store";
import getKhattabatMediaStore from "../../../../../../stores/khattabat-stores/messaging-stores/conversation-media-store";
import getKhattabatSharedMessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";

const KhattabatSendMessage = withLiteObserverAndTheme<{
  conversationID: string;
}>((props) => {
  const { conversationID } = props;
  const {
    messageField,
    isSending,
    setMessageField,
    sendMessage,
    getSendButton
  } = getKhattabatSharedMessagingStore(conversationID);
  const isKhattabaAiAdmin = getCorePersonalStore().isKhattabaAiAdmin.get();

  const shouldSend = isDefinedString(messageField.get()) && !isSending.get();
  const { labelKey, color } = getSendButton();

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      sx={{
        p: 1,
        bgcolor: "grey.100",
        borderTop: 1,
        borderColor: "divider"
      }}
    >
      <TextField
        size="small"
        fullWidth
        value={messageField.get()}
        placeholder={i18n.get("KHATTABAT_MESSAGE_PLACEHOLDER")}
        onChange={({ target }) =>
          setMessageField(khattabaConversationParsing(target.value))
        }
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            sendMessage();
          }
        }}
        sx={{ bgcolor: "background.paper" }}
      />
      {isKhattabaAiAdmin ? null : (
        <IconButton
          aria-label={i18n.get("KHATTABAT_UPLOAD_IMAGE")}
          onClick={() =>
            getKhattabatMediaStore(conversationID).handleImageUpload()
          }
        >
          <AddPhotoAlternateOutlinedIcon />
        </IconButton>
      )}
      <Button
        variant="contained"
        color={color}
        disabled={!shouldSend}
        endIcon={<SendIcon />}
        onClick={sendMessage}
        sx={{ flexShrink: 0 }}
      >
        {i18n.get(labelKey)}
      </Button>
    </Stack>
  );
});

export default KhattabatSendMessage;
